import { render } from "./KSFromTextArea.vue?vue&type=template&id=f98b2eee"
import script from "./KSFromTextArea.vue?vue&type=script&lang=js"
export * from "./KSFromTextArea.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__